import { Component, ElementRef, Inject, NgModule, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Utils } from '../../../../../utils/utils';
import { HttpClient } from '@angular/common/http';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { DatePipe } from '@angular/common';
import { MatSort, Sort } from '@angular/material/sort';


@Component({
    selector: 'history-lever-dialog',
    templateUrl: './history-lever-dialog.component.html',
    styleUrls: ['./history-lever-dialog.component.less'],
    standalone: false
})
export class HistoryLeverDialog implements OnInit {

    public dataSource = new MatTableDataSource<any>();
    @ViewChild('tableBody') tableBody!: ElementRef;
    label: string = "";
    isOpenTextAreaOverlay = false;
    constructor(
        private http: HttpClient,
        private dialogRef: MatDialogRef<HistoryLeverDialog>,
        @Inject('BASE_URL') private baseUrl: string,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public datePipe: DatePipe
    ) {
    }

    columnsToDisplay: string[] = [];

    ngOnInit(): void {
        if (this.data.callerComponent === 'AssessmentListComponent') {
            this.columnsToDisplay = ["action", "notes", "bestpractices", "user", "date"];
        } else if (this.data.callerComponent === 'ActionPriorizationListComponent') {
            this.columnsToDisplay = ["priority", "improvement", "comments", "user", "date"];
        }

        const lever = this.data.lever as AssessmentExcellenceLever
        this.label = `${lever.ExcellenceLever}`
        Utils.httpGetAssessmentLeverHistory(
            this.http,
            this.baseUrl,
            lever.WaveExcellenceLeverConfigId,
            this,
            function (tthis: HistoryLeverDialog, result: any) {
                tthis.dataSource.data = result.map((item: any, index: number) => ({
                    ...item,
                    KpiName: lever.KPIs.find(x => x.KpiDefinitionId === item.KpiDefinitionId)?.Name,
                    index: index
                }));
            }
        )
    }

    ngAfterViewInit() {
    }

    close() {
        this.dialogRef.close();
    }
}
